
import axios from "axios"
import * as signalR from "@microsoft/signalr"

export const startConnection = async => {

    let connection = new signalR.HubConnectionBuilder().withUrl("https://ocma-staging-api-c3h5cedhgef7h0ey.westus-01.azurewebsites.net/api/signalr/designautomation").withAutomaticReconnect().build();

    connection.start().then(() => {
        connection.invoke('getConnectionId').then((id) => {
            return id
        })

    });
}

let axiosConfig = {
  headers: {
      'Content-Type': 'application/json;charset=UTF-8',
      processData: false,
      contentType: false,
  }
};

export const startCADItem = async (item: any) : Promise<any> => {
  return new Promise(function(resolve, reject) {
    axios.post<any>('https://ocma-staging-api-c3h5cedhgef7h0ey.westus-01.azurewebsites.net/api/forge/designautomation/workitems',item, axiosConfig
    ).then(
      response => {
        resolve(response)
      },
      error => {
        console.error("startWorkItem error:", error)
        reject(error)
      }
    )
  })
}

// export const translateObject = async (objectKeys, connectionId) => {
//     const data = {
//         data: { 
//         "bucketKey": objectKeys[0], 
//         "objectName": objectKeys[1], 
//         "connectionId": connectionId 
//       }
//     }
//     const headers = {
//         'Content-Type': 'application/json',
//     }

//     return new Promise(function (resolve, reject) {
//         axios.post("/api/forge/modelderivative/jobs", data.data, { headers: headers }).then(
//       response => {
//         resolve(response.data)
//       },
//       error => {
//         reject(error)
//       }
//     )
//   })
// }


// export default {
//     startConnection,
//     startCADItem,
//   }